import {UserGroup} from '../model';
import {EventsPermissions} from './permissions/eventsPermissions';
import {GenericPermissions} from './permissions/genericPermissions';
import {ResidentsPermissions} from './permissions/residentsPermissions';
import {RoomsPermissions} from './permissions/roomsPermissions';
import {SettingsPermissions} from './permissions/settingsPermissions';
import {TasksPermissions} from './permissions/tasksPermissions';
import {UsersPermissions} from './permissions/usersPermissions';
import {InventoryPermissions} from './permissions/inventoryPermissions';
import {MedicationPermissions} from './permissions/medicationPermissions';
import {HealthLogPermissions} from './permissions/healthLogPermissions';
import {RelativesPermissions} from './permissions/relativesPermissions';
import {WorkTimePermissions} from './permissions/workTimePermissions';
import {PairedDevicesPermissions} from './permissions/pairedDevicesPermissions';

export type Permissions =
  | EventsPermissions
  | ResidentsPermissions
  | RoomsPermissions
  | SettingsPermissions
  | TasksPermissions
  | UsersPermissions
  | InventoryPermissions
  | MedicationPermissions
  | HealthLogPermissions
  | RelativesPermissions
  | WorkTimePermissions
  | PairedDevicesPermissions
  | GenericPermissions;

export type RolePermissions = Record<UserGroup, Permissions[]>;

export const rolePermissions: RolePermissions = {
  [UserGroup.Superusers]: ['FULL_ACCESS'],

  [UserGroup.Owners]: ['FULL_ACCESS'],

  [UserGroup.Admins]: ['FULL_ACCESS'],

  [UserGroup.Moderators]: [
    // Events
    'VIEW_EVENTS',
    'VIEW_LATEST_EVENTS',
    'CREATE_EVENT',
    'UPDATE_EVENT',
    // Residents
    'VIEW_RESIDENTS',
    'VIEW_RESIDENT',
    'UPDATE_RESIDENT_CONDITIONS',
    // Rooms
    'VIEW_ROOMS',
    // Tasks
    'VIEW_TASKS',
    'VIEW_TODAY_TASKS',
    'CREATE_TASK',
    'UPDATE_TASK',
    // Medication
    'CREATE_MEDICATION',
    'UPDATE_MEDICATION',
    'DISTRIBUTE_MEDICATION',
    // Health Log
    'CREATE_HEALTH_LOG_MEASUREMENT',
    // Inventory
    'VIEW_WAREHOUSES',
    'VIEW_WAREHOUSE',
    'CREATE_WAREHOUSE_ITEM',
    'UPDATE_WAREHOUSE_ITEM',
    'DELETE_WAREHOUSE_ITEM',
    // Generic
    'VIEW_MENU',
  ],

  [UserGroup.EmployeesInventory]: [
    // Events
    'VIEW_LATEST_EVENTS',
    'CREATE_EVENT',
    // Tasks
    'VIEW_TODAY_TASKS',
    // Inventory
    'VIEW_WAREHOUSES',
    'VIEW_WAREHOUSE',
    'CREATE_WAREHOUSE_ITEM',
    'UPDATE_WAREHOUSE_ITEM',
    'DELETE_WAREHOUSE_ITEM',
    // Generic
    'VIEW_MENU',
  ],

  [UserGroup.Employees]: [
    // Health Log
    'CREATE_HEALTH_LOG_MEASUREMENT',
    // Events
    'VIEW_LATEST_EVENTS',
    'CREATE_EVENT',
    // Tasks
    'VIEW_TODAY_TASKS',
  ],

  [UserGroup.AuthorizedRelatives]: [
    // Relatives
    'VIEW_RELATIVE',
    'VIEW_RELATIVES',
  ],
};
